import Image from "next/image";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getOrderDetail } from "../../../../api/order.api";
import { dataPaymentMethods } from "../../../../constant/card";
import { AuthContext } from "../../../../contexts/AuthContext";
import { DataContext } from "../../../../contexts/DataContext";
import { useLanguage } from "../../../../hooks/useLanguage";
import { buildPaymentPath } from "../../../../utils/buildPaymentPath";
import BaseButton from "../../../button/BaseButton";
import TextBaseV2 from "../../../textBaseV2/TextBaseV2";

export default function CompletePayment({
  timeHadOrder,
  oldOrder,
  handleCancelOrder,
}) {
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState("VISA");
  const [urlPayment, setUrlPayment] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  const handlePaymentMethodChange = (e) => {
    setSelectedPaymentMethod(e.target.value);
  };
  const { t } = useTranslation();

  const [orderDetail, setOrderDetail] = useState(null);

  const { user } = useContext(AuthContext);
  const { currentOrder } = useContext(DataContext);
  useEffect(() => {
    const link = buildPaymentPath({
      user,
      paymentOption: selectedPaymentMethod,
      currentOrder: currentOrder || oldOrder?.order,
    });

    setUrlPayment(link);
  }, [user, currentOrder, selectedPaymentMethod, oldOrder]);

  useEffect(() => {
    if (!currentOrder) return;

    const onGetOrderDetail = async () => {
      try {
        const response = await getOrderDetail(currentOrder?.id);
        setIsLoading(false);

        setOrderDetail(response.data);
      } catch (error) {
        setIsLoading(false);
      }
    };

    onGetOrderDetail();
  }, [currentOrder]);

  const { nameWithLanguage, currentLanguage } = useLanguage();

  if (isLoading) return;

  return (
    <div className="flex flex-col gap-10 px-4 py-6 bg-white border rounded-lg border-fourth-400">
      <div className="flex flex-col gap-4">
        <TextBaseV2 size="2xl" color="primary-500" className="font-bold">
          {t("order_summary")}
        </TextBaseV2>
        {oldOrder?.isExist && (
          <div>
            <div className="text-neutral-600 text-body-1 md:text-title-2">
              {t("title_order_pending")}
              <p
                className="block font-bold text-center text-purple-500 md:text-title-1 md:px-1 md:inline text-title-2"
                id="abc"
              >
                {timeHadOrder}
              </p>
            </div>
          </div>
        )}
        <div className="flex flex-col gap-6 pb-6 border-b border-solid border-b-fourth-400">
          {orderDetail?.orderItems?.map((item) => {
            return (
              <div key={item.id} className="flex flex-col gap-2">
                <TextBaseV2 size="md" color="fourth-100" className="font-bold">
                  {item?.ticketType ? item.ticketType[nameWithLanguage] : ""}
                </TextBaseV2>
                <div className="grid grid-cols-3 ">
                  <TextBaseV2 size="md" color="fourth-100">
                    SL
                  </TextBaseV2>
                  <TextBaseV2
                    size="md"
                    color="fourth-100"
                    className="flex justify-center"
                  >
                    {item?.quantity}
                  </TextBaseV2>
                  <div>
                    <TextBaseV2
                      size="md"
                      color="primary-500"
                      className="flex justify-end font-bold "
                    >
                      {currentLanguage === "en"
                        ? `${item.itemPrice.toFixed(2)} SR`
                        : `SR ${item.itemPrice.toFixed(2)}`}
                    </TextBaseV2>
                    {item?.discount !== 0 && (
                      <TextBaseV2
                        color="primary-500"
                        className="flex justify-end font-medium"
                      >
                        -{" "}
                        {currentLanguage === "en"
                          ? `${item?.discount.toFixed(2)} SR`
                          : `SR ${item?.discount.toFixed(2)}`}
                      </TextBaseV2>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        <div className="flex justify-between">
          <TextBaseV2 size="md" color="fourth-100">
            {t("total")}
          </TextBaseV2>
          <TextBaseV2 size="xl" color="primary-500" className="font-bold">
            {/* SR {orderDetail?.totalPrice.toFixed(2)} */}
            {currentLanguage === "en"
              ? `${orderDetail?.totalPrice.toFixed(2)} SR`
              : `SR ${orderDetail?.totalPrice.toFixed(2)}`}
          </TextBaseV2>
        </div>
      </div>
      <div className="flex flex-col gap-6">
        <TextBaseV2 size="2xl" color="primary-500" className="font-bold">
          {t("payment_methods")}
        </TextBaseV2>
        {dataPaymentMethods.map((item) => (
          <div
            key={item.id}
            className="flex flex-col gap-4 pb-6 border-b border-solid border-b-fourth-400"
          >
            <div className="flex items-center justify-between w-full">
              <div className="flex gap-2">
                <input
                  id={item.alt}
                  name="paymentMethod"
                  value={item.alt}
                  type="radio"
                  className="w-6 h-6 text-primary-200"
                  checked={selectedPaymentMethod === item.alt}
                  onChange={handlePaymentMethodChange}
                />
                <TextBaseV2 size="md" color="secondary-300">
                  {item.title}
                </TextBaseV2>
              </div>
              <div className="flex gap-2">
                <Image
                  src={`${item.source}`}
                  alt={item.alt}
                  width={60}
                  height={20}
                />
                {item.master_card && (
                  <Image
                    src={"/images/master_card.png"}
                    alt="master_card"
                    width={50}
                    height={20}
                  />
                )}
              </div>
            </div>
            {/* {selectedPaymentMethod === item.alt && <InformationCard />} */}
          </div>
        ))}
      </div>

      {/* <a href={urlPayment}>
        <p className=" text-body-1 md:text-title-2  rounded-lg flex justify-center items-center hover:bg-primary-100  bg-primary-200 text-white font-medium  lg:px-6 lg:py-3.5 px-5 py-3 max-lg:text-body-1 lg:text-title-2">
          {t("complete_check_out")}
        </p>
      </a> */}
      <div
        className={`md:flex-row md:flex ${
          oldOrder?.isExist ? "md:gap-x-6 lg:justify-end" : ""
        }`}
      >
        {oldOrder?.isExist && (
          <div className="flex justify-end w-full pt-6 lg:w-auto ">
            <div className={`w-full md:w-full lg:w-auto`}>
              <BaseButton
                onClick={handleCancelOrder}
                sizeButton="md"
                variant="outline"
                className="py-2.5 px-5 lg:px-8"
                isLoading={true}
              >
                <p className="font-bold text-purple-500 text-body-2 lg:text-body-1">
                  {t("cancel_order")}
                </p>
              </BaseButton>
            </div>
          </div>
        )}

        <div
          className={`flex justify-end w-full pt-6 ${
            oldOrder?.isExist ? "lg:w-auto" : ""
          }`}
        >
          <div
            className={`w-full ${
              oldOrder?.isExist ? "md:w-full lg:w-auto" : " md:w-auto"
            }`}
          >
            <a href={urlPayment}>
              <p className="   rounded-lg flex justify-center items-center hover:bg-primary-100  bg-primary-200 text-white font-bold  lg:px-6 lg:py-3.5 px-5 py-3 text-body-2 lg:text-body-1">
                {t("complete_check_out")}
              </p>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export const InformationCard = () => {
  const dataInput = [
    {
      id: 1,
      label: "Card number",
      placeholder: "Your card number",
    },
    {
      id: 2,
      label: "Expiration date",
      placeholder: "mm/yy",
    },
    {
      id: 3,
      label: "CCV",
      placeholder: "123",
    },
  ];
  return (
    <div className="flex flex-col gap-4">
      {dataInput.map((item) => (
        <div key={item.id} className="flex flex-col gap-2">
          <label className="font-bold text-body-1 text-fourth-100">
            {item.label}
          </label>
          <input
            className="flex items-center p-3 border border-solid rounded-lg outline-none border-fourth-400"
            placeholder={item.placeholder}
          />
        </div>
      ))}
    </div>
  );
};
